import { IconButton as MuiIconButton } from '@mui/material';
import * as React from 'react';
import { TIconButton } from './IconButton.types';

export const IconButton: TIconButton = (props) => {
  return <MuiIconButton {...props} />;
};
